var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row living-options"},[_c('language-selector'),_c('card-tabs',{staticClass:"col-12 w-100",attrs:{"tabs":[
      { 
        label: 'Rest',
        id: 'rest',
      },
      { 
        label: 'Category',
        id: 'category',
      },
      { 
        label: 'Live',
        id: 'live',
      },
      { 
        label: 'General',
        id: 'general',
      } ],"active-tab":_vm.activeTab},on:{"tabClick":_vm.navigateToTab},scopedSlots:_vm._u([{key:"rest",fn:function(){return [_c('SettingsRest')]},proxy:true},{key:"category",fn:function(){return [_c('SettingsCategory')]},proxy:true},{key:"live",fn:function(){return [_c('SettingsLive')]},proxy:true},{key:"general",fn:function(){return [_c('SettingsGeneral')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }